
import rulesConfig from './household_rules.json';

function getFieldValue(obj, path) {
  if (!obj || !path) return undefined;
  return path.split('.').reduce((acc, part) => (acc && acc[part] !== undefined) ? acc[part] : undefined, obj);
}

function evaluateOperator(leftVal, operator, rightVal, filterKey = null) {
  if (operator === "NOT_EMPTY") return Array.isArray(leftVal) ? leftVal.length > 0 : (leftVal !== null && leftVal !== undefined && leftVal !== "");
  if (operator === "IS_EMPTY") return Array.isArray(leftVal) ? leftVal.length === 0 : (leftVal === null || leftVal === undefined || leftVal === "");
  if (operator === "NOT_INCLUDE") {
    if (!Array.isArray(leftVal) || leftVal.length === 0) return false;
    return !leftVal.some(item => item && item.code === rightVal);
  }
  //object
  if (operator === "OBJECT_INCLUDE") {
    if (typeof leftVal !== "object" || leftVal === null) return false;
    return leftVal[filterKey] === rightVal
  }
  if (operator === "HAS_BOTH") {
    if (!Array.isArray(leftVal) || typeof rightVal !== "object") return false;
    const { group1, group2 } = rightVal;
    if (!Array.isArray(group1) || !Array.isArray(group2)) return false;
    const hasGroup1 = group1.some(code => leftVal.find(item => item.code === code));
    const hasGroup2 = group2.some(code => leftVal.find(item => item.code === code));
    
    return !(hasGroup1 && hasGroup2);
  }
  if (operator === "IN") {
    if (!Array.isArray(rightVal)) return false;
    return rightVal.includes(leftVal);
  }
  if (operator === "ARRAY_EQUAL_CI") {
    if (!Array.isArray(rightVal)) return false;
    if (!Array.isArray(leftVal)) return true;
    return leftVal.join(" ").toLowerCase() === rightVal.join(" ").toLowerCase();
  }
  if (operator === "==") return leftVal === rightVal;
  if (operator === "!=") return leftVal !== rightVal;
  if (operator === ">=") return Number(leftVal) >= Number(rightVal);
  if (operator === "<=") return Number(leftVal) <= Number(rightVal);
  if (operator === ">") return Number(leftVal) > Number(rightVal);
  if (operator === "<") return Number(leftVal) < Number(rightVal);
  return false;
}

function getDiffCount(str1, str2) {
  const len1 = str1.length;
  const len2 = str2.length;
  const track = Array(len2 + 1).fill(null).map(() => Array(len1 + 1).fill(null));

  for (let i = 0; i <= len1; i++) track[0][i] = i;
  for (let j = 0; j <= len2; j++) track[j][0] = j;

  for (let j = 1; j <= len2; j++) {
    for (let i = 1; i <= len1; i++) {
      const indicator = str1[i - 1] === str2[j - 1] ? 0 : 1;
      track[j][i] = Math.min(
        track[j][i - 1] + 1,
        track[j - 1][i] + 1,
        track[j - 1][i - 1] + indicator
      );
    }
  }
  return track[len2][len1];
}
function findSimilarSurnames(dataList, key = "surname", maxDiff = 3) {
  const visited = new Set();
  const resultGroups = [];

  for (let i = 0; i < dataList.length; i++) {
    if (visited.has(i)) continue;

    const currentGroup = [dataList[i]];
    
    for (let j = i + 1; j < dataList.length; j++) {
      if (visited.has(j)) continue;

      const str1 = String(dataList[i][key] ?? "").trim();
      const str2 = String(dataList[j][key] ?? "").trim();

      const diff = getDiffCount(str1, str2);

      if (diff > 0 && diff <= maxDiff) {
        currentGroup.push(dataList[j]);
        visited.add(j);
      }
    }

    if (currentGroup.length > 1) {
      visited.add(i);
      resultGroups.push({
        suspectedItems: currentGroup,
        totalMatches: currentGroup.length
      });
    }
  }

  return resultGroups;
}
const DataResolvers = {
  "STATIC": (config) => config.value,
  "FIELD": (config, targetData) => getFieldValue(targetData, config.field),
  "ARRAY_FIND": (config, targetData) => {
    const arrayData = targetData[config.arrayName] || [];
    const foundItem = arrayData.find(item => item.code === config.findValue);
    return foundItem ? (Number(foundItem[config.returnField]) || 0) : 0;
  },
  "ARRAY_COUNT": (config, targetData) => {
    let arrayData = config.arrayName ? targetData[config.arrayName] : targetData;
    if (!Array.isArray(arrayData)) return 0;
    if (config.nestedArrayField) {
      let parentItems = arrayData;
      if (config.codeField && config.targetCodes) {
        parentItems = arrayData.filter(item => config.targetCodes.includes(item[config.codeField]));
      }
      
      let nestedData = [];
      parentItems.forEach(item => {
        if (Array.isArray(item[config.nestedArrayField])) {
          nestedData = nestedData.concat(item[config.nestedArrayField]);
        }
      });
      arrayData = nestedData;
    }

    return arrayData.filter(item => {
      if (config.filters && Array.isArray(config.filters)) {
        return config.filters.every(cond => {
          const val = getFieldValue(item, cond.field);
          const compareVal = cond.valueField ? getFieldValue(targetData, cond.valueField) : cond.value;
          return evaluateOperator(val, cond.operator, compareVal);
        });
      }
      
      if (config.filterField) {
        const val = getFieldValue(item, config.filterField);
        const compareVal = config.filterValueField ? getFieldValue(targetData, config.filterValueField) : config.filterValue;
        return evaluateOperator(val, config.filterOperator, compareVal, config.filterKey);
      }
      
      return true;
    }).length;
  },
  "ARRAY_SUM": (config, targetData) => {
    const arrayData = config.arrayName ? targetData[config.arrayName] : targetData;
    if (!Array.isArray(arrayData)) return 0;

    return arrayData.reduce((sum, item) => {
      if (config.codeField && config.targetCodes) {
        if (!config.targetCodes.includes(item[config.codeField])) return sum;
      }
      if (config.nestedArrayField && Array.isArray(item[config.nestedArrayField])) {
        const nestedSum = item[config.nestedArrayField].reduce((nSum, nItem) => {
          return nSum + (Number(nItem[config.sumField]) || 0);
        }, 0);
        return sum + nestedSum;
      }

      return sum + (Number(item[config.sumField]) || 0);
      
    }, 0);
  },
  "MULTI_FIELD": (config, targetData) => {
    if (!config.fields || !Array.isArray(config.fields)) return [];
    return config.fields.map(field => getFieldValue(targetData, field));
  },
  "ARRAY_FIND_MULTI_FIELD": (config, targetData) => {
    const arrayData = config.arrayName ? targetData[config.arrayName] : targetData;
    if (!Array.isArray(arrayData) || !Array.isArray(config.fields)) return null;
    const foundItem = arrayData.find(item => getFieldValue(item, config.findField) == config.findValue);
    if (!foundItem) return null;
    return config.fields.map(field => getFieldValue(foundItem, field));
  },
  "SIMILAR_SURNAMES": (config, targetData) => {
    if (!Array.isArray(targetData)) return [];
    return findSimilarSurnames(targetData, config.key || "surname", config.maxDiff ?? 3);
  },
  "ARRAY_CODES": (config, targetData) => {
    const arrayData = config.arrayName ? targetData[config.arrayName] : targetData;
    if (!Array.isArray(arrayData)) return [];
    return arrayData
      .map(item => item && item[config.codeField])
      .filter(code => code !== undefined && code !== null);
  },
  "LAND_INVALID_COUNT": (config, targetData) => {
    const arrayData = config.arrayName ? targetData[config.arrayName] : targetData;
    if (!Array.isArray(arrayData)) return 0;
    return arrayData.filter(item => {
      const plotAmount = Number(item?.plot_amount) || 0;
      const squareWah = Number(item?.square_wah) || 0;
      const period = Number(item?.period) || 0;
      return plotAmount > 0 && (squareWah === 0 || period === 0);
    }).length;
  },
  "VEHICLE_INVALID_COUNT": (config, targetData) => {
    const arrayData = config.arrayName ? targetData[config.arrayName] : targetData;
    if (!Array.isArray(arrayData)) return 0;
    return arrayData.filter(item => {
      const value0 = Number(item?.value0) || 0;
      const value1 = Number(item?.value1) || 0;
      return value0 > 0 && value1 === 0;
    }).length;
  }
};

function resolveData(config, household, members) {
  if (!config || !DataResolvers[config.type]) return null;
  const targetData = config.source === "MEMBERS" ? members : household;
  
  return DataResolvers[config.type](config, targetData); 
}


const validateSurveyData = (surveyData) => {
  return new Promise((resolve) => {
    const errors = [];
    const warnings = [];
    const household = surveyData?.house_surveys?.[0] || {};
    const members = household.member_surveys || [];

    for (const rule of rulesConfig) {
        //the condition is the question need to answer before validate the rule, if the condition is not meet, the rule validation will be ignore ex. answer HH105 must not empty before validate HH106
      if (rule.condition) {
        const leftVal = resolveData(rule.condition.left, household, members);
        const rightVal = resolveData(rule.condition.right, household, members);
        
        if (!evaluateOperator(leftVal, rule.condition.operator, rightVal)) continue; 
      }

      if (rule.validation) {
        
        const leftVal = resolveData(rule.validation.left, household, members);
        const rightVal = resolveData(rule.validation.right, household, members);
        const isValid = evaluateOperator(leftVal, rule.validation.operator, rightVal);


        if (!isValid) {
          const item = {
            ruleId: rule.ruleId,
            message: rule.errorMessage,
            questionCode: rule.questionCode,
            step: rule.step
          };
          if (rule.type === "warning") {
            warnings.push(item);
          } else {
            errors.push(item);
          }
        }
      }
    }

    resolve({
        isPass: errors.length === 0,
        errors: errors,
        warnings: warnings
    });
  });
};

export { validateSurveyData, findSimilarSurnames };